import { createApp } from "vue"
import VirtualScroller from "vue-virtual-scroller"
import router, { renderRoutes } from "@/router/index"
import pinia from "@/stores"
import i18n from "@/i18n/index"
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
import getTailwindConfig from "@/plugins/checkTailwindConfig"
import setFontSizeConfig from "@/plugins/fontSizeConfig"
import loadCustomSetting from "@/plugins/loadCustomSetting"
import stopDoubleTap from "@/plugins/stopDoubleTap"
import { plugin as dayjsConfigPlugin } from "@/plugins/dayJsConfig"
import { setWindowTitle, setQueryPass, setCertification } from "@/plugins/setWebsiteInfo"
import initSentry from "@/plugins/sentry"
import { initImageModules } from "@/composables/functional/useImages"
import App from "./App.vue"

const execute = async () => {
  try {
    const app = createApp(App)

    app.use(i18n)
    app.use(VirtualScroller)
    app.use(pinia)

    const websiteInfoStore = useWebsiteInfoStore()
    const { getInitInfo } = websiteInfoStore

    setQueryPass()
    setCertification()
    dayjsConfigPlugin()
    stopDoubleTap()
    getTailwindConfig()
    setFontSizeConfig()

    let shouldNavigateToMaintenance = false

    try {
      renderRoutes(router, { optional: {} })
      const res = await getInitInfo()

      renderRoutes(router, { optional: res })

      setWindowTitle(res.webSiteDisplayName)
      await Promise.all([
        loadCustomSetting(res.webSiteCssName),
        initImageModules(res.webSiteCssName)
      ])
      initSentry({ app, router })
    } catch (err) {
      // 檢查是否為系統維護錯誤
      if (err?.isSystemMaintenance) {
        console.log(
          "System maintenance detected, rendering routes with SystemMaintenance"
        )
        renderRoutes(router, { optional: {} })
        shouldNavigateToMaintenance = true
      } else {
        // 其他錯誤：渲染基本路由
        renderRoutes(router, { optional: {} })
        console.error("Unexpected error:", err)
      }
    }

    // 統一註冊 router 和 mount app
    app.use(router)

    // 如果需要導航到維護頁面，在 mount 前先導航
    if (shouldNavigateToMaintenance) {
      await router.isReady()
      await router.push({ name: "SystemMaintenance" })
    }

    app.mount("#app")
  } catch {
    console.log("redirect")
  }
}

execute()
